const LibraryMaterialFilters = [
  {
    name: 'Library',
    searchState: 'always',
    pages: ['LibraryMaterial'],
    filterName: 'house',
    options: [
      {
        name: 'House of Commons',
        filterValue: 'Commons',
      },
      {
        name: 'House of Lords',
        filterValue: 'Lords',
      },
    ],
  },
  {
    name: 'Type',
    searchState: 'always',
    pages: ['LibraryMaterial'],
    filterName: 'articleTypes',
    options: [
      {
        name: 'Research Briefing',
      },
      {
        name: 'Constituency Casework',
      },
      {
        name: 'Data Dashboard',
      },
      {
        name: 'Insight',
      },
      {
        name: 'Debate Pack',
      },
      {
        name: 'In Focus',
      },
    ],
  },
];

export default LibraryMaterialFilters;
